import * as angular from "angular";
import { playService } from "../services/app";
import { playInteraction } from "../interaction/app";
import { UserboxController } from "./Userbox";
import { component } from "../Component";

export let playUserbox: angular.IModule = angular.module("play.userbox", [playInteraction.name, playService.name]);

playUserbox.component(
    "userbox",
    component({
        bindings: {
            textLoading: "<",
        },
        templateCacheUrl: "userbox/userbox.html",
        controllerAs: "ctrl",
        controller: UserboxController,
    })
);
